import { isoToFormatDate } from "./formatTime";

const getOverdueState = (overdue) => (overdue ? "過期" : "有效");

const getLeaseRentDate = (lease) => {
  const { startDate, endDate } = lease;
  return `${isoToFormatDate(startDate)} - ${isoToFormatDate(endDate)}`;
};

// scooter and car parking space number
const getParkingSpaceNumber = (lease) => {
  const { parkingLeases } = lease;
  // 機車: 0 and 1, 汽車: 2

  const scooterCount = 2;
  const scooterFields = parkingLeases
    .filter((pl) => pl.parkingSpace.type === "機車")
    .map((pl) => pl.parkingSpace.number)
    .sort((a, b) => Number(a) - Number(b));

  const carCount = 1;
  const carFields = parkingLeases
    .filter((pl) => pl.parkingSpace.type === "汽車")
    .map((pl) => pl.parkingSpace.number)
    .sort((a, b) => Number(a) - Number(b));

  return [
    ...scooterFields.concat(
      new Array(scooterCount - scooterFields.length).fill(""),
    ),
    ...carFields.concat(new Array(carCount - carFields.length).fill("")),
  ];
};

const addSearchedFields = (leases) => {
  leases.forEach((lease) => {
    const { room, renters, overdue } = lease;
    // parking space number
    const [scooterPSNumber, carPSNumber] = getParkingSpaceNumber(lease);

    const names = renters.map((renter) => renter.name).join(", ");
    const shownText = [
      room.roomNumber,
      names,
      renters[0]?.memberNumber,
      renters[0]?.phoneNumber,
      getOverdueState(overdue),
      getLeaseRentDate(lease),
      scooterPSNumber,
      carPSNumber,
    ];

    lease.searchedField = shownText.join(" ");
  });
};

export {
  getOverdueState,
  getLeaseRentDate,
  getParkingSpaceNumber,
  addSearchedFields,
};
